import script from "./SubscribeMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeMobile.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeMobile.vue?vue&type=style&index=0&id=05543988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05543988"]])

export default __exports__